module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-left-1.b4af1b29.png";